/* eslint-disable multiline-ternary */
import Header from 'src/components/header/Header';
import { BackNavigation, InfiniteScroll, Loader } from 'src/components/common';
import '../venture-detail/venturedetailpage.scss'
import VentureDetail from 'src/components/venture/venture-detail/VentureDetail';
import AboutFounderCard from 'src/components/cards/venture-cards/AboutFounderCard';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useGetIdentity, useUrlParamValue } from 'src/hooks';
import { useEffect, useMemo } from 'react';
import { clearComments, clearReplies, clearSingleVenture, clearVentureList, getSingleVenture, getVentureList } from 'src/store/venture/venture.slice';
import { useNavigate } from 'react-router-dom';
import { TVentureRequest } from 'src/services/apiEndpoint.types.ts/ventures/ventures.types';

export type TfilterProps = { endDate: string, programType: string[], industry: string[] }
const MyVentureDetail = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch();
    const { getIdentities } = useGetIdentity();
    const { singleVenture, ventureLoading } = useAppSelector(
        (store) => store.venture
    );
    const { paramValue } = useUrlParamValue();
    const id: string = paramValue({ paramName: 'id' }) as string;
    const { authenticatedId, loggedInUserType } = getIdentities();
    useEffect(() => {
        if (id && authenticatedId) {
            dispatch(getSingleVenture({ id, ...(!authenticatedId ? {} : loggedInUserType === 'Company' ? { companyId: authenticatedId } : { userId: authenticatedId }) }))
        }
        return () => {
            dispatch(clearSingleVenture())
        }
    }, [id, authenticatedId]);
    const fetchListVenture = () => {
        const payload: TVentureRequest = {
            limit: 5,
            page: 1,
            domain: singleVenture?.domain,
            ventureStage: singleVenture?.ventureStage,
            fundingStage: singleVenture?.fundingStage
        }
        dispatch(getVentureList(payload))
    };

    useEffect(() => {
        if (singleVenture) {
            fetchListVenture()
        }
        console.log((!!singleVenture && (singleVenture?.userId !== authenticatedId || singleVenture?.companyId !== authenticatedId)), singleVenture?.userId, 'authenticatedID', authenticatedId);

        // if (singleVenture && (singleVenture?.userId !== authenticatedId || singleVenture?.companyId !== authenticatedId)) {
        //     navigate(`/view-venture?id=${singleVenture?.id}`)
        // }

        return () => {
            dispatch(clearVentureList())
            dispatch(clearReplies());
            dispatch(clearComments());
        }
    }, [singleVenture]);

    const isViewerVentureCreater = useMemo(() => {
        return (singleVenture?.userId && singleVenture?.userId === authenticatedId) || (singleVenture?.companyId && singleVenture?.companyId === authenticatedId)
    }, [authenticatedId, singleVenture]) || false
    console.log(isViewerVentureCreater, 'isViewerVentureCreater');
    return (
        <>
            <InfiniteScroll
                className="venture-detail"
                onScrollEnd={() => { }}
                loading={false}
                showLoader={false}
                showFooter={false}
                moreItemsLeft={false}
            >
                <Header />
                <div className="venture-detail__body venture-detail__newBody">
                    {/* <BackNavigation text='Back' onClick={() => navigate(-1)}/> */}
                    {!ventureLoading && singleVenture && <>
                        <div className="venture-detail__body__feed">
                            <VentureDetail isViewerVentureCreater={isViewerVentureCreater} />
                        </div>

                        <div className="venture-detail__cards">
                            <AboutFounderCard />
                        </div>
                    </>}
                    {ventureLoading && <Loader />}
                </div>
            </InfiniteScroll>
        </>
    );
};

export default MyVentureDetail;
